import { STOCK_STATUS } from '@/common/constants';

const getStockStatus = (status, companyAvailability, delay) => {
  switch (status) {
    case STOCK_STATUS.COMMANDE:
    case STOCK_STATUS.NODIS:
      if (companyAvailability) {
        return 'nodis';
      }

      return 'info';
    case STOCK_STATUS.DELAI:
      return 'warning';
    case STOCK_STATUS.DISPO:
      if (delay === 12 || delay === 24) {
        return 'delay';
      }

      return 'success';
    default:
      return 'unknown';
  }
};

export default getStockStatus;
